import { render } from "./MessageBox.vue?vue&type=template&id=175fb560&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=175fb560&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175fb560"]])

export default __exports__